import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { IDocumentModel } from "@models";
import { CustomerSiteLogService, DocumentsService } from "@services";
import { SlickDialogModule, SlickFileDropModule, SlickFileListModule } from "@slick-components";

@Component({
	selector: "site-log-asset-photos-dialog",
	standalone: true,
	imports: [CommonModule, SlickDialogModule, SlickFileListModule, SlickFileDropModule],
	templateUrl: "site-log-asset-photos-dialog.component.html",
	styleUrls: ["site-log-asset-photos-dialog.component.scss"],
	providers: [CustomerSiteLogService, DocumentsService]
})
export class SiteLogAssetPhotosDialogComponent {
	@Output() photoCountChanged = new EventEmitter<number>();
	@ViewChild("photosDialog", { static: true }) photosDialog;

	jobId: number;
	customerDocumentKey: string;
	assetDocumentKey: string;
	assetName: string;
	photoType: string;
	photoTypeLabel: string;
	photos: IDocumentModel[] = [];
	isLoading = false;

	constructor(
		private customerSiteLogService: CustomerSiteLogService,
		private documentsService: DocumentsService) { }

	async open(jobId: number, customerDocumentKey: string, assetDocumentKey: string, assetName: string, photoType: "Before" | "After" | "Damage") {
		this.jobId = jobId;
		this.customerDocumentKey = customerDocumentKey;
		this.assetDocumentKey = assetDocumentKey;
		this.assetName = assetName;
		this.photoType = photoType;
		this.photoTypeLabel = photoType === "Damage" ? "Damage" : `${photoType} Photos`;
		this.photosDialog.showDialog();
		await this.loadPhotos();
	}

	async loadPhotos() {
		this.isLoading = true;
		try {
			this.photos = await this.customerSiteLogService.getSiteLogAssetPhotos(
				this.jobId, this.customerDocumentKey, this.assetDocumentKey, this.photoType) ?? [];
		} finally {
			this.isLoading = false;
		}
	}

	close() {
		this.photosDialog.hideDialog();
	}

	async onNewFilesAdded(files: IDocumentModel[]) {
		if (!files?.length)
			return;

		this.photos = await this.customerSiteLogService.saveSiteLogAssetPhotos(
			this.jobId, this.customerDocumentKey, this.assetDocumentKey, this.photoType, files);
		this.photoCountChanged.emit(this.photos.length);
	}

	async onFileChanged(fileModel: IDocumentModel) {
		await this.documentsService.updateDocument(fileModel);
	}

	async onFileDeleted(fileModel: IDocumentModel) {
		await this.documentsService.deleteDocument(fileModel.documentId);
		await this.loadPhotos();
		this.photoCountChanged.emit(this.photos.length);
	}

	async onDocumentClicked(documentModel: IDocumentModel) {
		await this.documentsService.openDocument(documentModel.documentId);
	}
}
